import React, { useState, useRef } from "react";
import "../../../website/feedTypes/feedComponents/uploadFeed.scss";
import {
  createFeed,
  fileUpload,
  fileUploadAfterSignURL,
  teacherUploadHomeWork,
} from "../../../../actions/emActions";
import Dropzone from "react-dropzone";
import { Spinner } from "reactstrap";
import { connect } from "react-redux";

const UploadHomework = (props) => {
  const { programs } = props;
  const [selectedFile, setSelectedFile] = useState(null);
  const [preview, setPreview] = useState("");
  const [text, setText] = useState("");
  const [imageId, setimageId] = useState("");
  const [feedType, setfeedType] = useState();
  const [teacherId, setteacherId] = useState("");
  const [studentIds, setstudentIds] = useState("");
  const [programInfo, setprogramInfo] = useState("");
  const [worksheetFileData, setworksheetFileData] = useState("");
  const [uploadLoading, setuploadLoading] = useState(false);
  const [programNameState, setprogramNameState] = useState({});

  const fileInputRef = useRef(null);

  if (props.programNameState.programName !== programNameState) {
    const { programNameState } = props;
    console.log("Program Info", programNameState);
    setprogramNameState(programNameState.programName);
    setprogramInfo(programNameState);

    var tutorData = JSON.parse(localStorage.getItem("loginData"));
    if (tutorData && programNameState) {
      setteacherId(tutorData.user.user_id);

      //To Get Students Logic
      let TeacherStudent = tutorData.teacher_students;

      if (TeacherStudent[programNameState.programName]) {
        var studentId = TeacherStudent[programNameState.programName].map((item) => item.student_id);

        setstudentIds(studentId.join(","));
      }
    }
  }

  const handleFileChange = (event) => {
    debugger;
    const file = event[0];
    setSelectedFile(file);

    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleChooseFile = () => {
    fileInputRef.current.click();
  };

  console.log("selectedFile", selectedFile);
  console.log("selectedFile", worksheetFileData);
  console.log("programInfo", programInfo);
  //   console.log("programInfo", programInfo && JSON.parse(programInfo)?.progid);
  // console.log("programInfo", JSON.parse(programInfo));

  const uploadFeedFunc = () => {
    setuploadLoading(true);
    const fileType = selectedFile?.type.includes("image") ? "image" : "video";

    fileUpload(selectedFile, teacherId.toString(), "tutor")
      .then((res) => {
        debugger;

        teacherUploadHomeWork(
          "0",
          0,
          programInfo?.courseId,
          programInfo?.program,
          teacherId,
          programInfo?.slotId,
          "teacher_upload",
          studentIds,
          text,
          res?.data[0]?.url,
          fileType
        ).then((res) => {
          window.location.reload();
          setuploadLoading(false);
        });
      })
      .catch((err) => {
        window.alert("Some Error occurred 6", err);
        setuploadLoading(false);
      });
  };

  return (
    <div className="row">
      <div className="col-md-6">
        <div className="card text-left uploadFeed">
          <div className="card-body">
            <div className="d-flex justify-content-between">
              <h5 className="card-title mb-0">Upload Photo or Video</h5>
              {selectedFile && (
                <button className="btn btn-light btn-sm" onClick={() => setSelectedFile("")}>
                  Change photo/video
                </button>
              )}
            </div>
            <form className="mt-3 row">
              {!selectedFile && (
                <div className="col-md-12">
                  <Dropzone onDrop={(acceptedFiles) => handleFileChange(acceptedFiles)}>
                    {({ getRootProps, getInputProps }) => (
                      <div {...getRootProps({ className: "dropzone" })}>
                        <input {...getInputProps()} />
                        <p>Drag 'n' drop file here, or click to select images/video</p>
                      </div>
                    )}
                  </Dropzone>
                </div>
              )}
              {selectedFile && (
                <>
                  <div className="col-md-8">
                    <div className="p-2">
                      {programs?.map((item) => (
                        <div>
                          <input
                            type="radio"
                            onClick={(e) => setprogramInfo(e.target.value)}
                            value={JSON.stringify(item)}
                            checked={
                              programInfo && JSON.parse(programInfo)?.progid === item?.progid
                            }
                          />
                          <label className="ml-2">{item?.prog_name}</label>
                        </div>
                      ))}
                    </div>
                  </div>
                  <div className="col-md-12 mt-3">
                    <textarea
                      type="text"
                      placeholder="Add caption here"
                      className="form-control form-control-sm"
                      id="textInput"
                      value={text}
                      onChange={(e) => setText(e.target.value)}
                    />
                  </div>
                  <div className="col-md-12">
                    {selectedFile && (
                      <div className="">
                        <div className="text-center mt-3">
                          {selectedFile.type.startsWith("image/") ? (
                            <img
                              width={"100%"}
                              // height={150}
                              src={preview}
                              alt="Preview"
                              className="rounded"
                            />
                          ) : (
                            <video controls className="w-100">
                              <source
                                src={URL.createObjectURL(selectedFile)}
                                type={selectedFile.type}
                              />
                              Your browser does not support the video tag.
                            </video>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                </>
              )}
              <div className="col-md-12 text-right mt-3">
                <button
                  // type="submit"
                  disabled={selectedFile && programInfo && !uploadLoading ? false : true}
                  className="uploadBtn"
                  onClick={() => uploadFeedFunc()}
                >
                  {uploadLoading ? <Spinner size="sm" /> : "Upload"}
                </button>
              </div>
              {/* <div className="col-md-12 mt-3">
              <button type="button" className="chooseFileBtn" onClick={handleChooseFile}>
              Choose Image or Video
              </button>
              </div>
              <div className="form-group">
              <input
              type="file"
              className="form-control-file d-none"
              id="fileInput"
              accept="image/*, video/*"
              onChange={handleFileChange}
              ref={fileInputRef}
              />
            </div> */}
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

function mapStateToProps(state) {
  return {
    programNameState: state.feedTutorRed.programName,
  };
}
export default connect(mapStateToProps, null)(UploadHomework);
